import React from 'react';
import { Container, Typography } from '@mui/material';

function About() {
  return (
    <Container>
      <Typography variant="h2">About Page</Typography>
      <Typography variant="body1">Learn more about us here.</Typography>
    </Container>
  );
}

export default About;
